import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

// MOCK VAULTS (TEMPORARY)
const mockVaults = [
  {
    id: 'vault1',
    vaultAlias: 'UGX Default',
    owner: 'Jonathan Mwebaze',
    balance: 12000.75,
    currencyCode: 'UGX',
    country: 'Uganda',
    flagCode: 'UG', // 🇺🇬 proper 2-letter code
  },
  {
    id: 'vault2',
    vaultAlias: 'USD Main',
    owner: 'Jonathan Mwebaze',
    balance: 24000.0,
    currencyCode: 'USD',
    country: 'United States',
    flagCode: 'US',
  },
  {
    id: 'vault3',
    vaultAlias: 'NGN Reserve',
    owner: 'Jonathan Mwebaze',
    balance: 950000,
    currencyCode: 'NGN',
    country: 'Nigeria',
    flagCode: 'NG',
  },
  {
    id: 'vault4',
    vaultAlias: 'KES Vault',
    owner: 'Jonathan Mwebaze',
    balance: 150000,
    currencyCode: 'KES',
    country: 'Kenya',
    flagCode: 'KE',
  },
];

export const getAllVaults = async ({ pageNumber }) => {
  try {
    const response = await axios.get(`/customer/vaults/${pageNumber}`);
    return response;
  } catch (error) {
    // MOCK FALLBACK
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: {
            vaults: mockVaults,
          },
        });
      }, 1000); // Simulate loading delay
    });
  }
};

export const useVaults = ({ pageNumber, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ['user_vaults', pageNumber],
    queryFn: () => getAllVaults({ pageNumber }),
  });
};
